import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.replace-all.js";
import { mapState } from 'vuex';
import { handleLocalStorage, getTheme } from '@/assets/js/utils.js';
export default {
  setup() {
    const {
      isDark
    } = getTheme();
    return {
      isDark
    };
  },
  data() {
    return {
      showSearch: false,
      searchInfo: '',
      showSortPop: false,
      selectPartyInfo: {},
      sortList: [{
        label: 'date',
        value: 'createTime',
        order: 'desc'
      }, {
        label: 'name',
        value: 'title',
        order: 'asc'
      }, {
        label: 'coHost',
        value: 'cohost',
        order: 'cohost'
      }],
      sortValue: {
        label: '',
        value: '',
        order: ''
      },
      scroll: {
        distance: 20,
        onScroll: this.getPartyList
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      partyListLoading: false,
      gcList: [],
      currentGlobalControlId: '',
      partyList: [],
      mutePartyList: [],
      movePartyInfo: {
        show: false,
        partyInfo: {}
      },
      selectAll: false,
      isSelectAll: false,
      partyExpand: [],
      array: [{
        url: [require('@/assets/img/partyline.png'), require('@/assets/img/partylineDark.png')],
        label: 'partyline',
        detail: 'partylineDetail'
      }, {
        url: [require('@/assets/img/Galleryview.png'), require('@/assets/img/GalleryviewDark.png')],
        label: 'GalleryView',
        detail: 'GalleryViewDetail'
      }, {
        url: [require('@/assets/img/Conference.png'), require('@/assets/img/ConferenceDark.png')],
        label: 'conference',
        detail: 'conferenceDetail'
      }, {
        url: [require('@/assets/img/Kiosk.png'), require('@/assets/img/KioskDark.png')],
        label: 'kiosk',
        detail: 'kioskDetail'
      }, {
        url: [require('@/assets/img/Globalcontrol.png'), require('@/assets/img/GlobalcontrolDark.png')],
        label: 'globalControl',
        detail: 'globalControlDetail'
      }],
      partyInfoList: [{
        label: 'createTime',
        icon: 'icon-Pending'
      }, {
        label: 'partyID',
        icon: 'icon-partyID'
      }, {
        label: 'host',
        icon: 'icon-renyuan-05'
      }],
      isHost: true,
      historyListScroll: {
        distance: 10,
        onScroll: this.getHistoryList
      },
      historyInfo: {
        pageNum: 1,
        pageSize: 20,
        hasNextPage: true
      },
      historyList: [],
      selectParty: '',
      globalControlInfoTips: {
        show: false,
        title: 'kioskHost.addToGlobalControl',
        cancel: 'commonFunction.cancel',
        save: 'Movepips.save',
        edit: false
      },
      globalName: '',
      showEmptyName: false,
      selectPartyList: [],
      kioskPartyList: []
    };
  },
  props: {
    currentModule: {
      type: String,
      default: 'party'
    }
  },
  created() {
    this.getGlobalControlList('created');
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config
    }),
    returnMuteClass() {
      let _str = '';
      if (!this.mutePartyList.length || this.mutePartyList.length == this.partyList.length) {
        _str = 'green';
      } else {
        _str = 'blue';
      }
      if (!this.currentGlobalControlId) _str += ' deepGray';
      for (const partyCode in this.movePartyInfo.partyInfo) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode && !item.checked && this.movePartyInfo.partyInfo[partyCode].rtilCodes.length > 0) {
            _str += ' deepGray';
          }
        });
      }
      return _str;
    },
    leftButtonText() {
      const _str = !this.mutePartyList.length || this.mutePartyList.length == this.partyList.length ? this.$t('kioskHost.muteAllMic') : this.$t('kioskHost.muteMic');
      return _str;
    },
    rightButtonText() {
      const _str = !this.mutePartyList.length || this.mutePartyList.length == this.partyList.length ? this.$t('kioskHost.unmuteAllMic') : this.$t('kioskHost.unmute');
      return _str;
    },
    judgeMuteButton() {
      let flag = false;
      if (!this.currentGlobalControlId) return true;
      for (const partyCode in this.movePartyInfo.partyInfo) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode && !item.checked && this.movePartyInfo.partyInfo[partyCode].rtilCodes.length > 0) {
            flag = true;
          }
        });
      }
      return flag;
    },
    returnNumber() {
      if (this.globalControlInfoTips.edit) {
        let selectNumber = 0;
        this.kioskPartyList.forEach(item => {
          if (item.checked && (!item.belongToGlobalControl || item.belongToGlobalControl == 2)) {
            selectNumber++;
          }
        });
        return selectNumber;
      } else {
        return this.selectPartyList.length;
      }
    }
  },
  methods: {
    async createParty() {
      this.selectPartyList = [];
      this.globalControlInfoTips.show = true;
      this.globalControlInfoTips.edit = false;
      this.getKioskPartyList();
    },
    getKioskPartyList() {
      const params = {
        globalControlId: this.State.globalControlId,
        pageSize: 100,
        pageNum: 1,
        sortField: '',
        sortDirection: ''
      };
      this.axios.post('/partyline-backend/kiosk/page', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          res.data.result.list.forEach(item => {
            if (item.belongToGlobalControl == 1 || item.belongToGlobalControl == 2) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          this.kioskPartyList = res.data.result.list;
        }
      });
    },
    saveControl() {
      if (!this.globalName) {
        this.showEmptyName = true;
        return;
      }
      this.globalControlInfoTips.show = false;
      if (this.globalControlInfoTips.edit) {
        this.updateGlobalControl();
      } else {
        this.createGroup();
      }
    },
    // 创建 globalControl
    createGroup() {
      const array = [];
      this.selectPartyList.forEach(item => {
        array.push(item.partyCode);
      });
      const params = {
        name: this.globalName,
        partyCodes: array
      };
      this.axios.post('/partyline-backend/globalControl/create', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.selectPartyList = [];
          this.$message.success(this.$t('mainWindow.success'));
          this.getGlobalControlList();
        }
      });
    },
    updateGlobalControl() {
      const addParty = [];
      const removeParty = [];
      const selectPartyList = [];
      this.selectPartyList.forEach(item => {
        selectPartyList.push(item.partyCode);
      });
      this.kioskPartyList.forEach(item => {
        if (!item.belongToGlobalControl && selectPartyList.includes(item.partyCode)) {
          addParty.push(item.partyCode);
        }
        if (item.belongToGlobalControl == 2 && item.checked == false) {
          removeParty.push(item.partyCode);
        }
      });
      const params = {
        id: this.State.globalControlId,
        name: this.globalName,
        appendPartyCodes: addParty,
        removePartyCodes: removeParty
      };
      this.axios.post('/partyline-backend/globalControl/update', params).then(async res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.selectPartyList = [];
          this.$message.success(this.$t('mainWindow.success'));
          this.getGlobalControlList();
        }
      });
    },
    blurName() {
      if (!this.globalName) {
        this.showEmptyName = true;
      } else {
        this.showEmptyName = false;
      }
    },
    returnClass(item) {
      let _str = '';
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl != 1 && item.checked) {
          _str = 'select';
        }
      } else {
        if (!item.belongToGlobalControl && item.checked) {
          _str = 'select';
        }
      }
      return _str;
    },
    returnDisabled(item) {
      if (this.globalControlInfoTips.edit) {
        if (item.belongToGlobalControl == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (item.belongToGlobalControl) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 用来保存要添加的 party
    savePartyInfo(val, item) {
      if (val) {
        item.checked = true;
        this.selectPartyList.push(item);
      } else {
        item.checked = false;
        this.selectPartyList.forEach((item1, index) => {
          if (item.partyCode == item1.partyCode) {
            this.selectPartyList.splice(index, 1);
          }
        });
      }
    },
    // 查询 Global Control list
    getGlobalControlList(created) {
      if (!created) this.partyListLoading = true;
      this.axios.post('/partyline-backend/globalControl/page', {
        pageNum: 1,
        pageSize: 100
      }).then(async res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          const array = [];
          result.list.forEach((item, index) => {
            const obj = Object.assign({}, item);
            obj.label = item.name;
            obj.index = index + 1;
            obj.edit = false;
            obj.id = item.globalControlId;
            obj.editName = '';
            obj.title = item.name;
            // 先创建假数据后面在用真数据覆盖
            if (item.partyCount) {
              obj.children = [{
                name: 'Test',
                createTime: ''
              }];
            } else {
              obj.children = [];
            }
            array.push(obj);
          });
          if (result.list.length > 0) {
            const list = await this.getCurrentGCParty(result.list[0]);
            array[0].children = list;
            this.State.globalControlId = array[0].globalControlId;
            this.currentGlobalControlId = array[0].globalControlId;
            handleLocalStorage('set', 'partyInfo', JSON.stringify({
              code: array[0].globalControlId
            }));
          } else {
            this.State.globalControlId = '';
          }
          this.gcList = JSON.parse(JSON.stringify(array));
          if (result.list.length < 1) {
            this.partyListLoading = false;
          }
        } else {
          this.partyListLoading = false;
        }
        if (created) {
          this.State.newPageLoading = false;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    // 获取当前 GC 下的子 party
    async getCurrentGCParty(item, node) {
      this.State.globalControlId = item.globalControlId;
      let array = [];
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: item.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          let result = res.data.result;
          if (node && node.level == 1) result = {
            ...result,
            ...node.data
          };
          this.selectPartyInfo = result;
          this.State.isTag = result.tag;
          if (this.State.isTag == 1) {
            this.State.soureTagType = 'Tag';
          }
          array = res.data.result.pageInfoVo.list;
          array.forEach((item, index) => {
            item.editName = item.name;
            item.globalControlId = this.State.globalControlId;
            item.id = item.partyCode;
            item.visible = false;
            item.edit = false;
            item.redTip = false;
            item.redMessage = '';
            item.index = index;
          });
          item.children = JSON.parse(JSON.stringify(array));
          if (result.mainWindowSetting) {
            result.mainWindowSetting.vfbResolution = result.mainWindowSetting.resolution;
            result.mainWindowSetting.vfbFrameRate = result.mainWindowSetting.frameRate;
            result.mainWindowSetting.vfbBitrate = result.mainWindowSetting.bitrate;
            result.mainWindowSetting.volume = result.mainWindowSetting.volume;
          }
          this.State.currentPartyInfo = {
            ...result,
            status: {},
            code: item.globalControlId,
            globalControlId: item.globalControlId
          };
          this.getHistoryList(result.partyCode, 'init');
        }
        this.partyListLoading = false;
      });
      return array;
    },
    changeParty(item, node) {
      if ((node === null || node === void 0 ? void 0 : node.level) != 1) return;
      this.selectParty = item.globalControlId;
      this.State.globalControlId = item.globalControlId;
      this.selectPartyInfo = item;
      if (this.currentGlobalControlId != item.globalControlId) {
        this.currentGlobalControlId = item.globalControlId;
        this.State.currentPartyInfo = {};
        this.getGlobalControlInfo(item);
      }
    },
    async getGlobalControlInfo(item) {
      if (!item.globalControlId) return;
      await this.axios.post('/partyline-backend/globalControl/pageInfo', {
        pageNum: 1,
        pageSize: 100,
        globalControlId: item.globalControlId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          if (result.mainWindowSetting) {
            result.mainWindowSetting.vfbResolution = result.mainWindowSetting.resolution;
            result.mainWindowSetting.vfbFrameRate = result.mainWindowSetting.frameRate;
            result.mainWindowSetting.vfbBitrate = result.mainWindowSetting.bitrate;
            result.mainWindowSetting.volume = result.mainWindowSetting.volume;
          }
          this.State.currentPartyInfo = {
            ...result,
            status: {},
            code: item.globalControlId,
            globalControlId: item.globalControlId
          };
        }
      });
    },
    returnTitleText(node, data) {
      let _str = '';
      if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
        _str = node.label;
      } else {
        if (data.name) {
          _str = data.name;
        } else {
          _str = new Date(data.createTime).toLocaleDateString() + '   ' + new Date(data.createTime).toLocaleTimeString();
        }
      }
      return _str;
    },
    returnContent(node, data) {
      let _str = '';
      if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
        _str = this.$t('kioskHost.partySelect') + data.partyCount;
      } else {
        _str = this.$t('common.code') + ': ' + this.$options.filters.returnStrByInfo(data.partyCode);
      }
      return _str;
    },
    returnInfoContent(item, type) {
      if (JSON.stringify(item) != '{}') {
        if (type === 'createTime') {
          return new Date(item.startPartyTime || item.createTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(item.startPartyTime || item.createTime).toLocaleTimeString() + '  (Web)';
        } else if (type === 'partyID') {
          return this.$options.filters.returnStrByInfo(item.id, item.id ? item.id.length === 9 ? 3 : 4 : 4);
        } else if (type === 'host') {
          return this.State.loginInfo.email;
        }
      } else {
        return '';
      }
    },
    hideGlobalPopup(item) {
      item.visible = false;
    },
    copyGlobalParty(item) {
      const domain = window.location.host;
      return 'https://' + domain + '/partyline?join_id=' + item.partyCode + `${this.env ? '&env=' + this.env : ''}`;
    },
    onCopy(item) {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    },
    saveGlobalName(data, node) {
      if ((node === null || node === void 0 ? void 0 : node.level) == 1) {
        this.axios.post('/partyline-backend/globalControl/rename', {
          globalControlId: data.globalControlId,
          name: data.editName
        }).then(res => {
          const {
            errorCode
          } = res.data;
          if (errorCode === '0x0') {
            data.label = data.editName;
            data.title = data.editName;
            data.name = data.editName;
            data.edit = false;
            this.State.currentPartyInfo.name = data.editName;
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
            Bus.$emit('changeTitle', data.editName);
          }
        });
      } else {
        this.axios.post('/partyline-backend/kiosk/updateTitle', {
          id: data.partyId,
          title: data.editName,
          _partyCode: data.partyCode
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            data.label = data.editName;
            data.title = data.editName;
            data.name = data.editName;
            data.edit = false;
            Bus.$emit('changePartyName', {
              partyCode: data.partyCode,
              name: data.editName
            });
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
          }
        });
      }
    },
    renameGlobal(node, data, type) {
      const obj = JSON.parse(JSON.stringify(data)); // copy一份避免重写被原来的值给覆盖
      data.edit = type === 'blur' ? false : !obj.edit;
      data.editName = obj.title || obj.name || new Date(obj.createTime).toLocaleDateString() + '   ' + new Date(obj.createTime).toLocaleTimeString();
      obj.redTip = false;
      obj.redMessage = '';
      data.visible = false;
      if (!data.edit) return;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        if ((node === null || node === void 0 ? void 0 : node.level) === 1) {
          this.$refs[`input${data.globalControlId}`].$refs.input.focus();
          this.$refs[`input${data.globalControlId}`].$refs.input.select();
        } else {
          this.$refs[`input${data.partyCode}`].$refs.input.focus();
          this.$refs[`input${data.partyCode}`].$refs.input.select();
        }
      });
    },
    editParty(data) {
      data.visible = false;
      this.getKioskPartyList();
      this.selectPartyList = [];
      this.globalControlInfoTips.show = true;
      this.globalControlInfoTips.edit = true;
      this.globalName = this.State.currentPartyInfo.name;
    },
    deleteGlobal(data) {
      this.axios.delete(`/partyline-backend/globalControl/${data.globalControlId}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == data.globalControlId) {
              this.State.pageSerBusRequestWs[item.globalControlId] && this.State.pageSerBusRequestWs[item.globalControlId].close();
              this.gcList.splice(index, 1);
            }
          });
          this.getGlobalControlList();
          Bus.$emit('updateTableList', {
            type: 'delete'
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    removeParty(info) {
      this.axios.post('/partyline-backend/globalControl/remove', {
        globalControlPartyId: info.globalControlPartyId
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.gcList.forEach((item, index) => {
            item.index = index;
            item.id = item.globalControlId;
            item.editName = item.name;
            if (item.globalControlId == info.globalControlId) {
              item.partyCount--;
              item.children.forEach((item1, index) => {
                if (item1.partyCode == info.partyCode) {
                  item.children.splice(index, 1);
                  Bus.$emit('updateTableList', {
                    type: 'remove',
                    index
                  });
                }
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    dealParticipantListUI(info) {
      const {
        type
      } = info;
      if (type === 'allCheck') {
        this.dealSelectAll(info);
      } else if (type === 'rowCheck') {
        this.dealRowCheck(info);
      } else if (type === 'partiRowCheck') {
        this.dealPartiRowCheck(info);
      } else {
        this.dealParticipantCheck(info);
      }
      // 处理全选按钮的 UI
      let selectAllFlag = true;
      this.partyList.forEach(item => {
        if (!item.checked) selectAllFlag = false;
      });
      if (selectAllFlag) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    // 全选的处理
    dealSelectAll(info) {
      const {
        val
      } = info;
      this.isSelectAll = val;
      if (val) {
        this.partyList.forEach(item => {
          item.checked = true;
          this.$set(this.movePartyInfo.partyInfo, item.partyCode, {});
          this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'rtilCodes', []);
          this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'taggerRtilCode', '');
          if (!this.mutePartyList.includes(item.partyCode)) this.mutePartyList.push(item.partyCode);
          item.participantList.forEach(item1 => {
            item1.rowChecked = true;
            item1.rowParticipantList.forEach(item2 => {
              item2.checked = true;
              this.movePartyInfo.partyInfo[item.partyCode].rtilCodes.push(item2.rtilCode);
              if (item2.tagger) {
                this.movePartyInfo.partyInfo[item.partyCode].taggerRtilCode = item2.rtilCode;
              }
            });
          });
        });
      } else {
        this.partyList.forEach(item => {
          item.checked = false;
          item.participantList.forEach(item1 => {
            item1.rowChecked = false;
            item1.rowParticipantList.forEach(item2 => {
              item2.checked = false;
            });
          });
        });
        this.mutePartyList = [];
        this.movePartyInfo.partyInfo = {};
      }
    },
    // 选择某一行 party 的处理
    dealRowCheck(info) {
      const {
        val,
        partyCode
      } = info;
      if (val) {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode) {
            // 如果没有先添加一个
            if (!this.movePartyInfo.partyInfo[partyCode]) {
              this.$set(this.movePartyInfo.partyInfo, partyCode, {});
            }
            if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
              this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
              this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
            }
            if (!this.mutePartyList.includes(item.partyCode)) this.mutePartyList.push(partyCode);
            item.participantList.forEach(item1 => {
              item1.rowChecked = true;
              item1.rowParticipantList.forEach(item2 => {
                item2.checked = true;
                if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(item2.rtilCode)) {
                  this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(item2.rtilCode);
                }
                if (item2.tagger) {
                  this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = item2.rtilCode;
                }
              });
            });
          }
        });
      } else {
        this.partyList.forEach(item => {
          if (item.partyCode == partyCode) {
            if (this.movePartyInfo.partyInfo[partyCode]) this.$delete(this.movePartyInfo.partyInfo, partyCode);
            this.mutePartyList.forEach((infPartyCode, index) => {
              if (infPartyCode == partyCode) {
                this.mutePartyList.splice(index, 1);
              }
            });
            item.participantList.forEach(item1 => {
              item1.rowChecked = false;
              item1.rowParticipantList.forEach(item2 => {
                item2.checked = false;
              });
            });
          }
        });
      }
    },
    // 选择某一个 party 里面一行的处理
    dealPartiRowCheck(info) {
      const {
        val,
        partyCode,
        index
      } = info;
      this.partyList.forEach(item => {
        if (item.partyCode == partyCode) {
          if (!this.movePartyInfo.partyInfo[partyCode]) {
            this.$set(this.movePartyInfo.partyInfo, partyCode, {});
          }
          if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
            this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
            this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
          }
          if (val) {
            this.$set(item.participantList[index], 'rowChecked', true);
            item.participantList[index].rowParticipantList.forEach(item1 => {
              item1.checked = true;
              if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(item1.rtilCode)) {
                this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(item1.rtilCode);
              }
              if (item1.tagger) {
                this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = item1.rtilCode;
              }
            });
          } else {
            this.$set(item.participantList[index], 'rowChecked', false);
            item.participantList[index].rowParticipantList.forEach(item1 => {
              item1.checked = false;
              this.movePartyInfo.partyInfo[partyCode].rtilCodes.forEach((rtilCode, index) => {
                if (this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
                  this.movePartyInfo.partyInfo[partyCode].rtilCodes.splice(index, 1);
                }
              });
              if (this.movePartyInfo.partyInfo[partyCode].taggerRtilCode == item1.rtilCode) {
                this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = '';
              }
            });
          }
          let rowFlag = true;
          let hadSelect = false;
          item.participantList.forEach(item1 => {
            if (!item1.rowChecked) {
              rowFlag = false;
            }
            item1.rowParticipantList.forEach(item2 => {
              if (item2.checked) {
                hadSelect = true;
              }
            });
          });
          // 如果当前 party下一个都没有选择了，则从 movePartyInfo 中移除数据
          if (!hadSelect && this.movePartyInfo.partyInfo[partyCode]) {
            this.$delete(this.movePartyInfo.partyInfo, partyCode);
          }
          if (rowFlag) {
            item.checked = true;
            if (!this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.push(partyCode);
            }
          } else {
            item.checked = false;
            if (this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.forEach((item2, index) => {
                if (item2 == partyCode) {
                  this.mutePartyList.splice(index, 1);
                }
              });
            }
          }
        }
      });
    },
    // 选择某一个 party 某一行的与会者的处理
    dealParticipantCheck(info) {
      const {
        val,
        participant,
        partyCode,
        index
      } = info;
      const rtilCode = participant.rtilCode;
      // 保存要移动的数据
      if (val) {
        if (!this.movePartyInfo.partyInfo[partyCode]) {
          this.$set(this.movePartyInfo.partyInfo, partyCode, {});
        }
        if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes) {
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'rtilCodes', []);
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', '');
        }
        if (!this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
          this.movePartyInfo.partyInfo[partyCode].rtilCodes.push(rtilCode);
        }
        if (participant.tagger) {
          this.$set(this.movePartyInfo.partyInfo[partyCode], 'taggerRtilCode', rtilCode);
        }
      } else {
        if (this.movePartyInfo.partyInfo[partyCode].rtilCodes.includes(rtilCode)) {
          this.movePartyInfo.partyInfo[partyCode].rtilCodes = this.movePartyInfo.partyInfo[partyCode].rtilCodes.filter(item => {
            return item != rtilCode;
          });
        }
        if (this.movePartyInfo.partyInfo[partyCode].taggerRtilCode == rtilCode) {
          this.movePartyInfo.partyInfo[partyCode].taggerRtilCode = '';
        }
      }
      // 根据勾选情况看是否要勾选行，和全部的 box
      this.partyList.forEach(info => {
        if (info.partyCode == partyCode) {
          let partiFlag = true;
          let rowFlag = true;
          info.participantList[index] && info.participantList[index].rowParticipantList.forEach(item => {
            if (!item.checked) partiFlag = false;
          });
          if (partiFlag) {
            this.$set(info.participantList[index], 'rowChecked', true);
          } else {
            this.$set(info.participantList[index], 'rowChecked', false);
          }
          let hadSelect = false;
          info.participantList.forEach(item1 => {
            if (!item1.rowChecked) rowFlag = false;
            item1.rowParticipantList.forEach(item2 => {
              if (item2.checked) {
                hadSelect = true;
              }
            });
          });
          // 如果当前 party下一个都没有选择了，则从 movePartyInfo 中移除数据
          if (!hadSelect && this.movePartyInfo.partyInfo[partyCode]) {
            this.$delete(this.movePartyInfo.partyInfo, partyCode);
          }
          if (rowFlag) {
            info.checked = true;
            if (!this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.push(partyCode);
            }
          } else {
            info.checked = false;
            if (this.mutePartyList.includes(partyCode)) {
              this.mutePartyList.forEach((mutePartyCode, index) => {
                if (mutePartyCode == partyCode) {
                  this.mutePartyList.splice(index, 1);
                }
              });
            }
          }
        }
      });
    },
    saveAndGetList(partyCode) {
      this.partyList.forEach(item => {
        if (this.partyExpand.includes(item.partyCode) && !item.hasLoadData) {
          item.hasLoadData = true;
          item.loading = true;
        }
        if (item.hasLoadData && !this.partyExpand.includes(item.partyCode)) {
          item.hasLoadData = false;
          item.loading = false;
        }
      });
      if (this.partyExpand.includes(partyCode)) {
        this.getParticipantList(partyCode, 'clear');
      }
    },
    async getParticipantList(partyCode, type) {
      await this.axios.get(`/partyline-backend/party/noLogin/onlineMembers/${partyCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          // 2 代表与会者列表
          let list = res.data.result[2];
          const participantList = [];
          this.partyList.forEach(item => {
            if (item.partyCode == partyCode) {
              // 保留之前的 check 状态
              if (list && list.length) {
                if (item.checked) {
                  const rtilCodes = [];
                  let taggerRtilCode = '';
                  list.forEach(item1 => {
                    item1.checked = true;
                    rtilCodes.push(item1.rtilCode);
                    if (item1.tagger) {
                      taggerRtilCode = item1.rtilCode;
                    }
                  });
                  // 由于可能会勾选行而不先获取数据所以还要往 movePartyInfo 里面添加数据用来 move
                  if (!this.movePartyInfo.partyInfo[item.partyCode]) {
                    this.$set(this.movePartyInfo.partyInfo, item.partyCode, {});
                  }
                  this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'rtilCodes', rtilCodes);
                  this.$set(this.movePartyInfo.partyInfo[item.partyCode], 'taggerRtilCode', taggerRtilCode);
                } else {
                  list.forEach(item1 => {
                    item1.checked = false;
                  });
                  if (type === 'clear' && this.movePartyInfo.partyInfo[item.partyCode]) {
                    this.movePartyInfo.partyInfo[item.partyCode].rtilCodes = [];
                    this.movePartyInfo.partyInfo[item.partyCode].taggerRtilCode = '';
                  }
                }
                // 默认一行 5 个
                const number = Math.ceil(list.length / 5);
                for (var i = 0; i < number; i++) {
                  participantList.push({
                    rowChecked: item.checked,
                    rowParticipantList: list.slice(0, 5)
                  });
                  list = list.slice(5);
                }
              }
              item.participantList = participantList;
              item.loading = false;
            }
          });
        }
      });
    },
    copyPartyId(item) {
      if (!item) return;
      const domain = window.location.host;
      return 'https://' + domain + '/partyline?join_id=' + item + `${this.env ? '&env=' + this.env : ''}`;
    },
    openPreviewPage(item) {
      return window.location.href.replace('manage', 'preview') + `?id=${item.code}`;
    },
    showTitle(item) {
      if (item.title) return item.title;
      return new Date(item.startPartyTime || item.createTime).toLocaleDateString() + '   ' + new Date(item.startPartyTime || item.createTime).toLocaleTimeString();
    },
    getHistoryList(partyCode, init) {
      if (!init && !this.historyInfo.hasNextPage) return;
      if (!init) this.historyInfo.pageNum++;
      const params = {
        operationName: null,
        variables: {
          page: this.historyInfo.pageNum,
          pageSize: this.historyInfo.pageSize,
          email: this.State.loginInfo.email,
          partyCode: partyCode || this.selectPartyInfo.code,
          channelMode: 17
        },
        query: 'query ($pageSize: Int!, $page: Int, $startTime: String, $endTime: String, $email: String, $title: String, $partyCode: String, $channelMode: String) {\n  partylineListPartyStatus(\n    page: $page\n    pageSize: $pageSize\n    startTime: $startTime\n    endTime: $endTime\n    email: $email\n    title: $title\n    partyCode: $partyCode\n  channelMode: $channelMode\n) {\n    edges {\n      node {\n        id\n        email\n        title\n        partyCode\n        channelMode\n        cname\n        createdTs\n        destroyedTs\n        status\n        maxCurrentParticipantNum\n        hostUserId\n        maxParticipantNum\n        __typename\n      }\n      __typename\n    }\n    pageInfo {\n      totalPages\n      currentPage\n      totalNum\n      pageSize\n      __typename\n    }\n    __typename\n  }\n}\n'
      };
      const url = location.protocol + '//' + this.Config.urlInfo.gatewayUrl + '/usage-service/graphql';
      this.axios.post(url, params).then(res => {
        if (!res) return;
        const result = res.data.data.partylineListPartyStatus;
        this.historyInfo.hasNextPage = result.pageInfo.totalNum - this.historyInfo.pageSize * this.historyInfo.pageNum > 0;
        if (init) {
          this.historyList = result.edges;
        } else {
          this.historyList = this.historyList.concat(result.edges);
        }
      }).catch(e => {
        console.log('get graphql failed');
      });
    },
    jumpControlPage() {
      window.open(`${location.origin}/partyline/control/globalControl?id=${this.currentGlobalControlId}`, '_blank');
    },
    showHistoryTime(type, key, item) {
      const startPartyTime = Number(item.node.createdTs) * 1000;
      const endPartyTime = Number(item.node.destroyedTs) ? Number(item.node.destroyedTs) * 1000 : new Date().getTime();
      const duration = endPartyTime - startPartyTime;
      const oneDay = 24 * 60 * 60 * 1000;
      const oneHours = 60 * 60 * 1000;
      const oneMinute = 60 * 1000;
      if (type === 'year') {
        return new Date(startPartyTime).toLocaleDateString().replaceAll('/', '-');
      } else if (type === 'hours') {
        //  如果会议持续时间超过一天则显示年月,一天毫秒 = 24 * 60 * 60 * 1000
        if (duration - oneDay > 0) {
          return key === 'start' ? new Date(startPartyTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(startPartyTime).toLocaleTimeString() : new Date(endPartyTime).toLocaleDateString().replaceAll('/', '-') + '   ' + new Date(endPartyTime).toLocaleTimeString();
        } else {
          const index = key === 'start' ? new Date(startPartyTime).toLocaleTimeString().lastIndexOf(':') : new Date(endPartyTime).toLocaleTimeString().lastIndexOf(':');
          return key === 'start' ? new Date(startPartyTime).toLocaleTimeString().slice(0, index) : new Date(endPartyTime).toLocaleTimeString().slice(0, index);
        }
      } else {
        //  如果会议持续时间超过一天则显示年月,一天毫秒 = 24 * 60 * 60 * 1000
        if (duration - oneDay > 0) {
          const day = parseInt(duration / oneDay);
          const hours = parseInt((duration - oneDay * day) / oneHours);
          const minutes = parseInt((duration - oneDay * day - hours * oneHours) / oneMinute);
          return day + ' day' + ' ' + hours + ' hour' + ' ' + minutes + ' minutes';
        } else if (duration - oneHours > 0) {
          const hours = parseInt(duration / oneHours);
          const minutes = parseInt((duration - hours * oneHours) / oneMinute);
          return parseInt(duration / oneHours) + ' hour' + ' ' + minutes + ' minutes';
        } else if (duration - oneMinute > 0) {
          return ((endPartyTime - startPartyTime) / 1000 / 60).toFixed(0) + ' minutes';
        } else {
          return (endPartyTime - startPartyTime) / 1000 + ' seconds';
        }
      }
    },
    clearMayHavePopover() {
      this.gcList.forEach(item => {
        item.visible = false;
        item.children && item.children.forEach(item1 => {
          item1.visible = false;
        });
      });
    }
  }
};